import { AlertTriangle } from "lucide-react";

export default function Disclaimer({ text, testid = "disclaimer" }) {
  return (
    <div data-testid={testid} className="flex items-start gap-2 rounded-xl border border-[#FBBF24]/30 bg-[rgba(251,191,36,0.06)] px-3 py-2">
      <AlertTriangle className="w-4 h-4 text-[#FBBF24] shrink-0 mt-0.5" />
      <p className="flex-1 min-w-0 text-xs text-[#FBBF24]/90 leading-relaxed break-words">{text}</p>
    </div>
  );
}
